"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = exports.ImgComponent = exports.BlurhashWrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var styles_1 = require("../styles");
exports.BlurhashWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n\n  > * {\n    width: 100% !important;\n    height: 100% !important;\n    object-fit: cover !important;\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n\n  > * {\n    width: 100% !important;\n    height: 100% !important;\n    object-fit: cover !important;\n  }\n"])));
exports.ImgComponent = styled_components_1.default.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n  width: 100%;\n"], ["\n  display: block;\n  width: 100%;\n"])));
exports.Wrapper = (0, styled_components_1.default)(styles_1.Wrapper)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", " {\n    position: ", ";\n    top: 0;\n    left: 0;\n    height: ", ";\n    object-fit: ", ";\n    object-position: ", ";\n    opacity: ", ";\n    transition: opacity 0.2s ease;\n  }\n"], ["\n  ", " {\n    position: ", ";\n    top: 0;\n    left: 0;\n    height: ", ";\n    object-fit: ", ";\n    object-position: ", ";\n    opacity: ", ";\n    transition: opacity 0.2s ease;\n  }\n"])), exports.ImgComponent, function (_a) {
    var $aspectRatio = _a.$aspectRatio, $fit = _a.$fit;
    return ($aspectRatio || $fit ? 'absolute' : 'relative');
}, function (_a) {
    var $aspectRatio = _a.$aspectRatio, $fit = _a.$fit;
    return ($aspectRatio || $fit ? '100%' : 'auto');
}, function (_a) {
    var $fit = _a.$fit;
    return $fit;
}, function (_a) {
    var $position = _a.$position;
    return $position;
}, function (_a) {
    var $loaded = _a.$loaded;
    return ($loaded ? 1 : 0);
});
var templateObject_1, templateObject_2, templateObject_3;
